// Lets any section open the assistant panel, optionally with a question.
const EVENT = 'assistant:open';

export const openAssistant = (question) =>
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { question } }));

export const onOpenAssistant = (handler) => {
  const listener = (e) => handler(e.detail?.question);
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
};
